import type { SiniestroStatus } from '../../../model/kartera-api-model'
import { daysFromToday, formatCompactDate } from '../../../utils/dates'
import type { DateInput } from '../../../utils/dates'
import { labelize, statusKey } from '../../customers/common/customer-common'

export {
    BITACORA_FILTERS,
    chipClass,
    errorMessage,
    formatActivityDate,
    formatCount,
    formatSpokenDate,
    labelize,
    NOTE_TYPES,
    noteMeta,
    pageWindow,
    personName,
    RamoMark,
    ramoName,
    statusKey,
} from '../../customers/common/customer-common'
export type { BitacoraFilter } from '../../customers/common/customer-common'
export { aseguradoraName, extTone, fileExt, isBusy, RAMOS, selectMenu, vehicleLabel } from '../../policies/common/policy-common'
export type { LoadState } from '../../policies/common/policy-common'
export { formatCompactDate }

export const CLAIMS_PATH = '/siniestros'
export const NEW_CLAIM_PATH = `${CLAIMS_PATH}/nuevo`

export interface ClaimLocationState {
    backUrl?: string
    detailId?: number
}

export const editClaimLocation = (id: number, backUrl = CLAIMS_PATH): { pathname: string; state: ClaimLocationState } => ({
    pathname: `${CLAIMS_PATH}/${id}/edit`,
    state: { backUrl },
})

export const SINIESTRO_STATUS: Array<{ id: SiniestroStatus; label: string }> = [
    { id: 'captura', label: 'Captura' },
    { id: 'faltante', label: 'Faltante del cliente' },
    { id: 'enviado', label: 'Enviado a la aseguradora' },
    { id: 'aceptado', label: 'Aceptado' },
    { id: 'rechazado', label: 'Rechazado' },
    { id: 'finalizado', label: 'Finalizado' },
]

/** Estatus cerrados: el listado los oculta por defecto y no muestran aviso de atraso. */
export const CLOSED_STATUS: SiniestroStatus[] = ['finalizado', 'rechazado']

export const isClosedClaim = (status?: string | null) => CLOSED_STATUS.includes(statusKey(status) as SiniestroStatus)

export const siniestroStatusLabel = (status?: string | null) =>
    SINIESTRO_STATUS.find((item) => item.id === statusKey(status))?.label || labelize(status) || '—'

export const siniestroChip = (status?: string | null) => {
    const value = statusKey(status)
    if (value === 'finalizado' || value === 'aceptado') return 'bg-k-ok-soft text-k-ok'
    if (value === 'rechazado') return 'bg-k-danger-soft text-k-danger-ink'
    if (value === 'enviado') return 'bg-tone-blue text-tone-blue-ink'
    return 'bg-tone-orange text-tone-orange-ink'
}

export interface ClaimStatusChip {
    label: string
    className: string
}

export const claimStatusView = (status?: string | null): ClaimStatusChip => ({
    label: siniestroStatusLabel(status),
    className: siniestroChip(status),
})

export interface ResolutionView {
    label: string
    note: string
    noteClass: string
}

const daysText = (days: number) => `${days} ${days === 1 ? 'día' : 'días'}`

/** Fecha estimada de resolución con aviso de atraso mientras el siniestro siga abierto. */
export const resolutionView = (fecha?: DateInput, status?: string | null): ResolutionView => {
    const label = formatCompactDate(fecha) || '—'
    const days = daysFromToday(fecha)
    if (days == null || isClosedClaim(status)) return { label, note: '', noteClass: 'text-k-muted' }
    if (days < 0) return { label, note: `Atrasado ${daysText(Math.abs(days))}`, noteClass: 'text-k-danger' }
    if (days === 0) return { label, note: 'Se resuelve hoy', noteClass: 'text-tone-orange-ink' }
    return { label, note: `En ${daysText(days)}`, noteClass: days <= 7 ? 'text-tone-orange-ink' : 'text-k-muted' }
}
